import React, { useEffect, useState, useRef } from "react";
//import SearchComponent from "../../Search/SearchComponent/SearchComponent";
import "./codigoqr.css";
//import { Personal } from "../../../json/Prueba";
//const res = await fetch('/JSON/LicitacionesEstatales/licitaciones2023.json')
//const licitaciones2023 = await res.json()


const CodigoQR = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="contenedor2">
            <span className="textoencabezado2">VALIDAR QR</span>
          </div>
        </div>
        <div className="col-12">
          <div className="contenedor2">
            <span className="texto2" style={{fontSize:"28px"}}>Aquí encontrarás los pasos para validar tu documento</span>
          </div>
        </div>
        <div className="col-12">
        <br></br>  
        </div>
        {/* <div className="col-6">
          <div className="transparencia_title">
            <img src="../contenido/infografias/CodigoQR/Infografia.jpg" width="650" alt="MDN" />
          </div>
        </div> */}
        <div className="col-12">
          <div className="contenedor">
            <video src="../contenido/infografias/CodigoQR/Codigos.mp4" style={{minWidth:"400px", maxWidth:"800px",height:"auto"}} autoPlay={true} controls playsInline>
              Tu navegador no admite el elemento.
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodigoQR;
